import { routeGroup } from '#/routing/routes';

export const redirectToSavedSearchRoute = routeGroup.route(
  'saved-searches/:savedSearchId',
);

/**
 * This is not a real route - the route is defined using constants instead of :lang/:segment
 * so that they're more accurate and easier to understand
 */
export const searchJobsRouteReference = routeGroup.route('-lang/-segment', [
  'areasOfFocus',
  'education',
  'functions',
  'hasSalary',
  'jobType',
  'locale',
  'location',
  'locationType',
  'orgType',
  'page',
  'professionalLevel',
  'q',
  'radius',
  'recency',
  'sort',
  'synonymId',
]);

/**
 * This is not a real route - the route is defined using constants instead of :lang/:segment
 * so that they're more accurate and easier to understand
 */
export const searchInternshipsRouteReference = routeGroup.route(
  '-lang/-segment',
  [
    'areasOfFocus',
    'functions',
    'locale',
    'location',
    'locationType',
    'orgType',
    'page',
    'payment',
    'q',
    'radius',
    'recency',
    'sort',
    'synonymId',
  ],
);

/**
 * This is not a real route - the route is defined using constants instead of :lang/:segment
 * so that they're more accurate and easier to understand
 */
export const searchVolopsRouteReference = routeGroup.route('-lang/-segment', [
  'areasOfFocus',
  'endsGT',
  'functions',
  'canBeDoneInADay',
  'locale',
  'location',
  'locationType',
  'page',
  'q',
  'radius',
  'recency',
  'sort',
  'source',
  'startsLT',
  'welcome',
]);

/**
 * This is not a real route - the route is defined using constants instead of :lang/:segment
 * so that they're more accurate and easier to understand
 */
export const searchEventsRouteReference = routeGroup.route('-lang/-segment', [
  'areasOfFocus',
  'endsGT',
  'functions',
  'isIdealistDay',
  'locale',
  'location',
  'locationType',
  'page',
  'q',
  'radius',
  'recency',
  'sort',
  'source',
  'startsLT',
]);

/**
 * This is not a real route - the route is defined using constants instead of :lang/:segment
 * so that they're more accurate and easier to understand
 */
export const searchOrgsRouteReference = routeGroup.route('-lang/-segment', [
  'areasOfFocus',
  'locale',
  'location',
  'orgType',
  'page',
  'q',
  'radius',
  'sort',
]);
